import { ReportError } from "shared/errors";

export class ReportService {
  httpClient;
  baseUrl;

  constructor(baseUrl, apiClient) {
    this.httpClient = apiClient;
    this.baseUrl = baseUrl;
  }

  downloadreport = async (data) => {
    const url = `${this.baseUrl}/reports`;
    const response = await this.httpClient.post(url, data, {
      responseType: 'blob'
    });
    // isSuccessful is only returned as false when an error has occurred
    if (response.isSuccessful === false) {
      throw new ReportError();
    }
    return response;
  };
}
